export * from './candidate-form-page.component';
